import dayjs from 'dayjs';
export { default as dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
import localizedFormat from 'dayjs/plugin/localizedFormat.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import isoWeek from 'dayjs/plugin/isoWeek.js';

// src/internal/util/datetime.ts
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);
var defaultTimezone = "UTC";
function setupDayjs(opts = {}) {
  if (opts.timezone) {
    defaultTimezone = opts.timezone;
    dayjs.tz.setDefault(opts.timezone);
  }
  if (opts.locale) {
    dayjs.locale(opts.locale);
  }
}
function getDefaultTimezone() {
  return defaultTimezone;
}
function parseApiDate(value) {
  if (value === null || value === void 0 || value === "") return null;
  const raw = value instanceof Date ? value.toISOString() : value;
  return dayjs(raw).tz(defaultTimezone);
}
var ISO_DATETIME_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
function toApiDate(value) {
  if (!value) return void 0;
  return value.format("YYYY-MM-DD");
}

export { ISO_DATETIME_RE, getDefaultTimezone, parseApiDate, setupDayjs, toApiDate };
//# sourceMappingURL=chunk-WH2C42V5.js.map
//# sourceMappingURL=chunk-WH2C42V5.js.map